var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileUrl)?_c('div',{class:{clickable: _vm.enabled},style:({
      width: _vm.previewWidth + 'px',
      height: _vm.previewHeight + 'px',
    }),on:{"click":function($event){_vm.enabled ? _vm.togglePreview() : null}}},[_c('transition',{attrs:{"name":"scale-transition","mode":"out-in","duration":"100"}},[(!_vm.previewing)?_c('div',{key:"notPreviewing",attrs:{"title":_vm.$t('radiospotPreview')}},[(!_vm.closingtime)?_c('v-layout',{attrs:{"nowrap":"","justify-center":"","align-center":""}},[_c('v-img',{attrs:{"src":"/static/radiospot_play_button.svg","width":_vm.previewWidth,"cover":""}})],1):_c('v-icon',{style:({
            'font-size': _vm.previewIconSize + 'em',
            width: _vm.previewWidth + 'px',
            height: _vm.previewHeight + 'px',
          })},[_vm._v("\n          campaign\n        ")])],1):_c('v-icon',{key:"previewing",staticClass:"radiopreview-icon msr--text",class:{
          pulse: !_vm.$store.state.common.runtimeEnv.firefox,
          safari: _vm.$store.state.common.runtimeEnv.safari,
        },style:({
          'font-size': _vm.previewIconSize - 0.5 + 'em',
          width: _vm.previewWidth + 'px',
          height: _vm.previewHeight + 'px',
        })},[_vm._v("\n        pause\n      ")])],1),_vm._v(" "),_c('audio',{ref:"audiopreview",staticClass:"hidden",attrs:{"preload":"metadata","src":_vm.fileUrl},on:{"ended":function($event){_vm.enabled ? _vm.stopPreview() : null}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MiniPreviewAudio.vue?vue&type=template&id=6f0a28a2&scoped=true
// module id = 1521
// module chunks = 5